import _ from 'lodash';
import Qs from 'qs';

export function getUrl(path, queryParams) {
  return path + convertParamsToSearch(queryParams);
}

function convertParamsToSearch(params) {
  let search = _.chain(params)
    .omitBy(v => v === false || v === null || v === undefined)
    .mapValues(v => (v === true ? '1' : v))
    .value();

  if (!_.isEmpty(search)) {
    return `?${Qs.stringify(search)}`;
  }
  return '';
}



// WEBPACK FOOTER //
// ./src/scripts/adapters/routes/url.js